// extracted by mini-css-extract-plugin
export default {"modalOverlay":"xC-z","modalContent":"yC-z","header":"zC-z","close":"AC-z"};